import SeamlyBaseError from './seamly-base-error'

export default class SeamlyConfigurationError extends SeamlyBaseError {
  constructor(originalError?: any, ...params) {
    super(originalError, ...params)

    this.name = 'SeamlyConfigurationError'
    this.langKey = 'errors.configError'
  }
}
